"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeTrackingLogFieldLogic = void 0;
var time_tracking_log_fieldtype_1 = require("./time-tracking-log.fieldtype");
Object.defineProperty(exports, "TimeTrackingLogFieldLogic", { enumerable: true, get: function () { return time_tracking_log_fieldtype_1.TimeTrackingLogFieldLogic; } });
